module.exports = "/assets/dist/images/shopper-sm.png?f861af56c06589b97f7235a51d522593";